import { COLORS } from 'styles/colors'

type BabyPacifferProps = {
	width?: number
	height?: number
	color?: string
}

export const BabyPaciffer = (props: BabyPacifferProps) => {
	const { width = '16px', height = '17px', color = COLORS.pinkText } = props
	return (
		<svg width={width} height={height} viewBox='0 0 16 17' fill='none'>
			<g clipPath='url(#clip0_837_39119)'>
				<path
					d='M4.95762 6.84291C5.16378 6.53785 5.08361 6.12342 4.77855 5.91726C4.47349 5.7111 4.05906 5.79128 3.8529 6.09634L4.95762 6.84291ZM4.57677 8.5971C4.88183 8.80326 5.29625 8.72308 5.50241 8.41802C5.70857 8.11296 5.6284 7.69854 5.32334 7.49238L4.57677 8.5971ZM11.9756 11.9365C11.7943 12.2046 11.2399 12.4498 10.1121 12.256C9.05094 12.0737 7.72585 11.5299 6.41292 10.6426L5.66635 11.7473C7.09896 12.7155 8.59909 13.3489 9.88627 13.5701C11.1067 13.7798 12.4237 13.6546 13.0803 12.683L11.9756 11.9365ZM6.41292 10.6426C5.09999 9.75532 4.10121 8.72866 3.5363 7.8121C2.93584 6.83787 2.95658 6.23202 3.1378 5.96387L2.03308 5.2173C1.37645 6.18891 1.75152 7.45753 2.40124 8.51169C3.0865 9.62352 4.23373 10.7792 5.66635 11.7473L6.41292 10.6426ZM3.1378 5.96387C3.28184 5.75072 3.65817 5.54137 4.44185 5.58047C5.19693 5.61814 6.16975 5.88737 7.22087 6.39956L7.80492 5.20095C6.64585 4.63617 5.49458 4.298 4.50829 4.24879C3.55062 4.20101 2.56831 4.4253 2.03308 5.2173L3.1378 5.96387ZM9.83418 8.12155C10.7753 8.93049 11.45 9.77371 11.8054 10.5004C12.1761 11.2582 12.1258 11.7141 11.9756 11.9365L13.0803 12.683C13.6369 11.8594 13.4448 10.8175 13.0032 9.91452C12.5462 8.98034 11.7379 7.99968 10.7033 7.11041L9.83418 8.12155ZM3.8529 6.09634C3.52146 6.58678 3.52979 7.12788 3.71355 7.57686C3.88832 8.00386 4.21865 8.35508 4.57677 8.5971L5.32334 7.49238C5.1291 7.36111 5.00039 7.20095 4.94753 7.0718C4.90367 6.96464 4.91578 6.90483 4.95762 6.84291L3.8529 6.09634Z'
					fill={color}
				/>
				<path
					d='M8.18229 4.45293C9.0384 3.18613 10.4427 2.90575 11.2658 3.46201C12.0889 4.01827 12.3526 5.42585 11.4964 6.69265C11.3739 6.874 11.1835 7.05447 10.9182 7.25121C10.7047 7.40952 10.4738 7.55669 10.2189 7.71913C10.1528 7.76127 10.0851 7.80443 10.0157 7.84908C9.60676 8.11198 9.11606 8.43524 8.72867 8.87035C8.25046 8.47545 7.73874 8.12962 7.19397 7.8332C7.45321 7.31148 7.57014 6.73562 7.66157 6.25818C7.6771 6.17709 7.69189 6.09816 7.70633 6.02111C7.762 5.72404 7.81243 5.4549 7.8797 5.19778C7.96329 4.87824 8.05973 4.63428 8.18229 4.45293Z'
					stroke={color}
					strokeWidth='1.33333'
				/>
				<path
					d='M9.17399 12.5087C8.14319 14.034 6.07106 14.4349 4.54576 13.4041C3.02046 12.3733 2.61959 10.3012 3.65039 8.77588'
					stroke={color}
					strokeWidth='1.33333'
				/>
			</g>
			<defs>
				<clipPath id='clip0_837_39119'>
					<rect
						width='16'
						height='16'
						fill='white'
						transform='translate(0 0.216797)'
					/>
				</clipPath>
			</defs>
		</svg>
	)
}
